import styled from 'styled-components';

export const StyledForm = styled.form`
  height: 100%;
`;
